module.exports = __webpack_public_path__ + "img/book_mark.f0b7bc72.svg";